import { CheckCircleIcon } from "lucide-react";
import { twMerge } from "tailwind-merge";

import { Dialog, DialogBody, DialogCloseButton } from "@/components/dialog";
import { Modal } from "@/components/modal";

interface ReviewBrandDetailsModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
}

export function ReviewBrandDetailsModal({
  isOpen,
  onClose,
}: ReviewBrandDetailsModalProps) {
  return (
    <Modal
      classNames={{
        modal: twMerge("w-[400px] rounded-xl"),
        modalOverlay: twMerge(
          "sm:items-center sm:justify-center items-center justify-center",
        ),
      }}
      isDismissable
      isOpen={isOpen}
      onOpenChange={onClose}
    >
      <Dialog alert>
        <DialogCloseButton />
        <DialogBody className="gap-4 px-6 py-6">
          <div className="flex flex-col items-center gap-4 text-center">
            <div className="flex self-start h-12 w-12 items-center justify-center rounded-full bg-bg-success-primary">
              <CheckCircleIcon className="size-6 text-text-success-primary" />
            </div>

            <div className="space-y-1">
              <h2 className="text-lg font-semibold text-text-primary">
                Review your brand details
              </h2>
              <p className="text-sm text-text-secondary">
                Your brand profile page is ready! Please take a moment to check
                the information and make any updates to ensure everything is
                accurate.
              </p>
            </div>
          </div>
        </DialogBody>
      </Dialog>
    </Modal>
  );
}
